import { Dialog } from "@material-ui/core";
import { QrReader } from "react-qr-reader";
import { useState } from "react";

const QRScanner = ({ data, setData, setOnScanQR, onScanQR }) => {
  const [selected, setSelected] = useState("environment");
  const [loadingScan, setLoadingScan] = useState(false);

  const handleClose = () => setOnScanQR(false);

  const handleScan = async (scanData) => {
    setLoadingScan(true);
    console.log(`loaded data data`, scanData);
    if (scanData && scanData !== undefined) {
      console.log(`loaded >>>`, scanData);
      setData(scanData);
      setLoadingScan(false);
      setOnScanQR(false);

      // setPrecScan(scanData);
    }
  };
  const handleError = (err) => {
    console.error(err);
  };
  return (
    <Dialog open={onScanQR} onClose={handleClose}>
      <div
        className="QRScanner"
        style={{ height: "350px", width: "300px", display: "flex", flexDirection: "column" }}
      >
        <select onChange={(e) => setSelected(e.target.value)}>
          <option value={"Back Cam"}>Back Camera</option>
          <option value={"Front Cam"}>Front Camera</option>
        </select>
        <QrReader
          facingMode={selected}
          delay={1000}
          onError={handleError}
          onResult={handleScan}
          // chooseDeviceId={()=>selected}
          style={{ width: "300px" }}
        />
      </div>
    </Dialog>
  );
};

export default QRScanner;
